<template>
  <v-data-table
      dense
      :headers="headers"
      :items="DRIVER_AUTHORITY"
      :hide-default-footer="true"
      class="elevation-1">
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Driver Authority</v-toolbar-title>
          <v-divider
            class="mx-4"
            inset
            vertical>
          </v-divider>
          <v-spacer></v-spacer>
          <v-dialog
            max-width="600"
            v-model="dialog">
            <template v-slot:activator="{ on, attrs }">
              <v-select
                v-if="IS_ADMINISTRATOR || IS_DRIVER"
                @change="newDriver()"
                :items="DRIVERS"
                v-model="selectedDriver"
                :item-text="item => `${item.givenName},
                      ${item.familyName}`"
                item-value="id"
                label="New driver authority"
                return-object
                dense>
              </v-select>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text>
                <ValidationObserver ref="driverAuthority" v-slot="{ invalid, valid, errors }">
                  <v-form v-model="driverAuthorityValid">
                    For driver: {{ editedItem.givenName }} {{ editedItem.familyName }}
                    <v-container>
                      <v-row>
                        <v-col cols="12">
                          <ValidationProvider
                            name="Mobile Number"
                            :rules="'required'"
                            v-slot="{errors}" slim>
                            <v-text-field
                                v-mask="mobileMask"
                                v-model="editedItem.mobileNumber"
                                label="Mobile number"
                                append-icon="mdi-cellphone"
                                placeholder="04XX-XXX-XXX"
                                :error-messages="errors">
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="6">
                          <v-checkbox
                            label="Point to Point Licence"
                            v-model="editedItem.pointToPoint">
                          </v-checkbox>
                        </v-col>
                        <v-col cols="6">
                          <ValidationProvider
                            rules="required"
                            name="Drivers licence number"
                            vid="driversLicenceNumber"
                            v-slot="{ errors }">
                            <v-text-field
                              v-model="editedItem.driversLicence"
                              :error-messages="errors"
                              label="Drivers licence"
                              append-icon="mdi-card-bulleted-outline"
                              placeholder="'Enter drivers licence'">
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-menu
                            v-model="menu1"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px">
                            <template v-slot:activator="{ on }">
                              <validation-provider
                                name="Drivers licence expiry"
                                :rules="'required'"
                                v-slot="{errors}" slim>
                                <v-text-field
                                  v-model="fmtDriversLicenceExpiryDate"
                                  label="Drivers licence expiry"
                                  append-icon="mdi-calendar"
                                  readonly
                                  :error-messages="errors"
                                  v-on="on">
                                </v-text-field>
                              </validation-provider>
                            </template>
                            <v-date-picker
                              v-model="editedItem.driversLicenceExpiryDate"
                              @input="menu1 = false">
                            </v-date-picker>
                          </v-menu>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <ValidationProvider
                            rules="required"
                            name="Drivers authority number"
                            vid="driverAuthorityNumber"
                            v-slot="{ errors }">
                            <v-text-field
                              v-model="editedItem.driverAuthorityNumber"
                              :error-messages="errors"
                              label="Driver authority number"
                              append-icon="mdi-card-bulleted-outline"
                              placeholder="'Enter drivers authority number'">
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-menu
                            v-model="menu2"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px">
                            <template v-slot:activator="{ on }">
                              <validation-provider
                                name="Driver authority expiry"
                                :rules="'required'"
                                v-slot="{errors}" slim>
                                <v-text-field
                                  v-model="fmtDriverAuthorityExpiryDate"
                                  label="Driver authority expiry"
                                  append-icon="mdi-calendar"
                                  readonly
                                  :error-messages="errors"
                                  v-on="on">
                                </v-text-field>
                              </validation-provider>
                            </template>
                            <v-date-picker
                              v-model="editedItem.driverAuthorityExpiryDate"
                              @input="menu2 = false">
                            </v-date-picker>
                          </v-menu>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-form>
                </ValidationObserver>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="close">
                  Cancel
                </v-btn>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="saveDriver">
                  Save
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title>
                Are you sure you want to delete this item?
              </v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                <v-btn color="blue darken-1" text @click="deleteConfirm">OK</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon
          small
          class="mr-2"
          @click="editDriver(item)">
          mdi-pencil
        </v-icon>
        <v-icon
          v-if="IS_ADMINISTRATOR"
          small
          class="mr-2"
          @click="deleteDriverAuthority(item)">
          mdi-eraser
        </v-icon>
      </template>
      <template v-slot:item.givenName="{ item }">
        {{ item.givenName }}
      </template>
      <template v-slot:item.familyName="{ item }">
        {{ item.familyName }}
      </template>
       <template v-slot:item.mobileNumber="{ item }">
        {{ item.mobileNumber }}
      </template>
      <template v-slot:item.driversLicence="{ item }">
        {{ item.driversLicence }}
      </template>
      <template v-slot:item.pointToPoint="{ item }">
        <v-checkbox
          disabled
          v-model="item.pointToPoint">
        </v-checkbox>
      </template>
      <template v-slot:item.driversLicenceExpiryDate="{ item }">
        {{ $moment(item.driversLicenceExpiryDate).format(DISPLAY_DATE_FORMAT) }}
      </template>
      <template v-slot:item.driverAuthorityNumber="{ item }">
        {{ item.driverAuthorityNumber }}
      </template>
      <template v-slot:item.driverAuthorityExpiryDate="{ item }">
        {{ $moment(item.driverAuthorityExpiryDate).format(DISPLAY_DATE_FORMAT) }}
      </template>
  </v-data-table>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { mask } from 'vue-the-mask';
/* eslint-disable camelcase */
import { required } from 'vee-validate/dist/rules';
/* eslint-enable camelcase */
import
{
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from 'vee-validate';
import storeConstants from '@/store/storeConstants';

setInteractionMode('eager');

extend('required', required);

export default {
  name: 'DriverAuthority',
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  mounted() {
    if (this.IS_ADMINISTRATOR || this.IS_DRIVER) {
      this.GET_DRIVER_AUTHORITY();
    }
  },
  data: () => ({
    mobileMask: '####-###-###',
    menu2: false,
    menu1: false,
    editedIndex: undefined,
    editedItem: undefined,
    deleteItem: undefined,
    dialog: false,
    dialogDelete: false,
    selectedDriver: undefined,
    driverAuthorityValid: false,
    headers: [
      { text: 'Actions', value: 'actions', sortable: false },
      { text: 'Given Name', value: 'givenName' },
      { text: 'Family Name', value: 'familyName' },
      { text: 'Mobile Number', value: 'mobileNumber' },
      { text: 'Is Point-to-Point', value: 'pointToPoint' },
      { text: 'Drivers Licence #', value: 'driversLicence' },
      { text: 'Drivers Licence Expiry', value: 'driversLicenceExpiryDate' },
      { text: 'Driver Authority #', value: 'driverAuthorityNumber' },
      { text: 'Driver Authority Expiry', value: 'driverAuthorityExpiryDate' },
    ],
  }),
  directives: {
    mask,
  },
  computed: {
    ...mapGetters([
      storeConstants.DRIVERS,
      storeConstants.DRIVER_AUTHORITY,
      storeConstants.DISPLAY_DATE_FORMAT,
      storeConstants.ISO_8601_FORMAT,
      storeConstants.IS_ADMINISTRATOR,
      storeConstants.IS_DRIVER,
    ]),
    formTitle() {
      return this.editedIndex === -1 ? 'New Driver Authority' : 'Edit Driver Authority';
    },
    fmtDriverAuthorityExpiryDate() {
      if (!this.editedItem.driverAuthorityExpiryDate) {
        return null;
      }
      return this
        .$moment(this.editedItem.driverAuthorityExpiryDate)
        .format(this.DISPLAY_DATE_FORMAT);
    },
    fmtDriversLicenceExpiryDate() {
      if (!this.editedItem.driversLicenceExpiryDate) {
        return null;
      }
      return this
        .$moment(this.editedItem.driversLicenceExpiryDate)
        .format(this.DISPLAY_DATE_FORMAT);
    },
  },
  methods: {
    ...mapActions([storeConstants.GET_DRIVER_AUTHORITY,
      storeConstants.SAVE_DRIVER_AUTHORITY,
      storeConstants.DELETE_DRIVER_AUTHORITY,
    ]),
    editDriver(item) {
      this.editedIndex = this.DRIVER_AUTHORITY.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    newDriver() {
      this.editedItem = {
        userId: this.selectedDriver.id,
        givenName: this.selectedDriver.givenName,
        familyName: this.selectedDriver.familyName,
        mobileNumber: null,
        driversLicence: null,
        driversLicenceExpiryDate: null,
        driverAuthorityNumber: null,
        driverAuthorityExpiryDate: null,
        pointToPoint: null,
      };
      this.editedIndex = -1;
      this.dialog = true;
      this.selectedDriver = {};
      return null;
    },
    saveDriver() {
      this.$refs.driverAuthority.validate().then((success) => {
        this.driverAuthorityValid = success;
        if (this.driverAuthorityValid) {
          this.SAVE_DRIVER_AUTHORITY(this.editedItem)
            .then(() => {
              this.dialog = false;
              this.selectedDriver = {};
              this.editedItem = {};
            },
            (error) => {
              this.SET_ALERT_DETAILS({ alertText: error.response.data.error, showAlert: true });
              this.isLoading = false;
            })
            .catch(() => {
              this.isLoading = false;
            });
        }
      });
    },
    close() {
      this.dialog = false;
    },
    closeDelete() {
      this.deleteItem = null;
      this.dialogDelete = false;
    },
    deleteDriverAuthority(item) {
      this.deleteItem = item;
      this.dialogDelete = true;
    },
    deleteConfirm() {
      this.DELETE_DRIVER_AUTHORITY(this.deleteItem.userId)
        .then(() => {
          this.deleteItem = null;
          this.dialogDelete = false;
        },
        (error) => {
          this.SET_ALERT_DETAILS({ alertText: error.response.data.error, showAlert: true });
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
      this.dialogDelete = false;
    },
  },
};
</script>
